import styled from 'styled-components';

import { DenialListRowMenuProps } from 'components/denialList/DenialListRowMenu';
import Menu from 'components/shared/menu';
import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import EditIcon from 'svg/EditIcon';
import ThreeDotMenu from 'svg/ThreeDotMenu';
import TrashIcon from 'svg/TrashIcon';

// Admin counterpart to DenialListRowMenu: identical kebab UI, but gated on the admin item-level
// permissions so a View Only Olio Admin sees no actions menu at all.
export default function AdminDenialListRowMenu({ denialListItem, onEdit, onDelete }: DenialListRowMenuProps) {
  const { profile } = useProfile();

  const canEdit = profile.has(PERMISSIONS.adminDenialListItemEdit);
  const canDelete = profile.has(PERMISSIONS.adminDenialListItemDelete);

  // View-only admins get no actions menu at all.
  if (!canEdit && !canDelete) return null;

  return (
    <Menu $size='small'>
      <Menu.Trigger>
        <KebabButton type='button' aria-label='Row actions'>
          <ThreeDotMenu />
        </KebabButton>
      </Menu.Trigger>
      <Menu.Content position='right'>
        {canEdit && (
          <Menu.Item onClick={() => onEdit(denialListItem)}>
            <EditIcon width={14} height={14} />
            Edit Entry
          </Menu.Item>
        )}
        {canEdit && canDelete && <Menu.Divider />}
        {canDelete && (
          <DeleteItem onClick={() => onDelete(denialListItem)}>
            <TrashIcon width={14} height={14} color={colors.accentRed} />
            Delete Entry
          </DeleteItem>
        )}
      </Menu.Content>
    </Menu>
  );
}

const KebabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const DeleteItem = styled(Menu.Item)`
  color: ${({ theme }) => theme.colors.accentRed};
`;
